exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.container {\r\n  flex: initial;\n}\r\n", ""]);

